module.exports = __webpack_public_path__ + "7bf140ab46a7630cb7c40d6ef87cc4ba.svg";